import { render, staticRenderFns } from "./StudentFlags.vue?vue&type=template&id=033e58e4&scoped=true&"
import script from "./StudentFlags.vue?vue&type=script&lang=js&"
export * from "./StudentFlags.vue?vue&type=script&lang=js&"
import style0 from "./StudentFlags.vue?vue&type=style&index=0&id=033e58e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e58e4",
  null
  
)

export default component.exports